import React from 'react';
import styled from 'styled-components';
import { Trans, useTranslation } from 'react-i18next';
import { shouldShowExistingPatientLoginCta } from '../../util';
import { colors } from '../../../../constants/colors';

const LoginLink = styled.span.withConfig({ componentId: 'sc-1lg11vv-0' })`
  color: ${colors.link};
  text-decoration: none;
  -webkit-font-smoothing: antialiased;
  cursor: pointer;
`;

const Root = styled.div.withConfig({ componentId: 'sc-1lg11vv-1' })`
  color: ${colors.blueish};
  font-size: 16px;
  margin: 15px auto 5px;
  text-align: center;
`;

type Props = {
  form: any;
  handleAndTrackLoginFromReturningPatientToggle: (...args: any[]) => any;
  location: any;
  hideLoginLink?: boolean;
  isLoggedIn: boolean;
};

const ExistingPatientCta = ({
  location,
  form,
  handleAndTrackLoginFromReturningPatientToggle,
  isLoggedIn,
}: Props) => {
  const { t } = useTranslation('bookingWidget');
  if (!shouldShowExistingPatientLoginCta(form, isLoggedIn, location)) {
    return null;
  }
  return (
    <Root>
      <Trans i18nKey="logInToYourSolvAccount" t={t}>
        Foo
        <LoginLink onClick={handleAndTrackLoginFromReturningPatientToggle}>Log in cta</LoginLink>
      </Trans>
    </Root>
  );
};

export default ExistingPatientCta;
